import * as React from 'react';
import { memo } from "react";
import type { PageData } from "../../js/data/pageData.ts";
import { AssetMode } from "../../js/enums.ts";
import { getImgUrl } from "../../js/mediaLibrary/assetUtils.ts";
import { format } from "date-fns";

type Props = React.ComponentPropsWithoutRef<"div"> & {
	news: PageData
}

function NewsBox({news, ...otherProps}: Props) {
	return (<>
			<div className="flex flex-col h-full bg-white rounded-2xl overflow-hidden">
				<img
					src={news?.cover && getImgUrl(AssetMode.Thumb, news.coverId, news.cover.filename, 443, 301)}
					alt=""
					width={443}
					height={301}
					className="w-full"
				/>
				<div className="flex flex-col h-full items-center text-center">
					{/*<p className="text-base">{format(news.obj.creationDate, "dd / MM / yyyy")}</p>*/}
					<h4 className="leading-snug mb-8 mt-10">{news.title}</h4>
					{news.blurb && <p className="mb-12 leading-loose">{news.blurb}</p>}
					<div className="flex-grow"/>
					<a href={news.absoluteUrl} className="button" title={news.title}>READ MORE</a>
				</div>
			</div>
		</>
	);
}

export default memo(NewsBox);
